import { render, staticRenderFns } from "./SolutionListNew.vue?vue&type=template&id=266ace74&scoped=true&"
import script from "./SolutionListNew.vue?vue&type=script&lang=js&"
export * from "./SolutionListNew.vue?vue&type=script&lang=js&"
import style0 from "./SolutionListNew.vue?vue&type=style&index=0&id=266ace74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ace74",
  null
  
)

export default component.exports